import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
import { clientChartData, clientOverview, getAllClients } from "../../Redux/Actions/DashOptions";
import { constructOptions } from "../../Utils/helper";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Modal } from '@mui/material'
import { RevenueChart } from "../../Common/RevenueChart";
import DatePicker from "react-multi-date-picker";
import { toast } from "react-toastify";


const TableViewDashboard = () => {
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    const [heading, setHeading] = useState()
    const currentYear = new Date().getFullYear();

    const [selectedRange, setSelectedRange] = useState([
        new Date(currentYear, 0, 1),
        new Date(currentYear, 11, 31),
    ]);

    const showClientData = useSelector((state) => state?.DashOptionsSlice?.clientOverviewData?.clients)

    const clientData = useSelector((state) => state?.DashOptionsSlice?.allClients?.data) // client list data 
    const clientListLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading) // ckecking client list loading

    const clientGraphData = useSelector((state) => state?.DashOptionsSlice?.clientOverviewChart?.data)

    const handleFilterClient = (selectedValue) => {
        if (selectedValue) {
            dispatch(clientOverview({ name: selectedValue?.value }))
        } else {
            dispatch(clientOverview())

        }
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "60%",
        bgcolor: 'background.paper',
        borderRadius: '12px',
        boxShadow: 24,
        p: 4,
    };
    const handleClientAnalytics = (selectedItem) => {
        setHeading(selectedItem)
        setOpen(true)
        dispatch(clientChartData({ client_id: selectedItem?.id }))
    }

    const handleClose = () => {
        setOpen(false)
        setSelectedRange([''])
    }

    const handleChangeChart = (range) => {
        if (!range || range.length < 2) return;
        const [start, end] = range;

        const startDate = start?.toDate?.() || start;
        const endDate = end?.toDate?.() || end;

        setSelectedRange([startDate, endDate]);

        const payload = {
            start_month: startDate.toLocaleString('default', { month: 'long' }),
            end_month: endDate.toLocaleString('default', { month: 'long' }),
            year: startDate.getFullYear(),
            client_id: heading?.id
        };

        dispatch(clientChartData(payload)).then((res) => {
            if (res?.type !== "dashboard-chart-client/fulfilled") {
                toast.error('Data not found')
            }
        })
    }

    useEffect(() => {
        dispatch(clientOverview())
        dispatch(getAllClients())
    }, [])

    return (
        <div className="w-full md:flex-1 bg-white rounded-xl shadow mt-4">
            <div className="bg-white rounded-lg p-4 mb-6">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
                    <div>
                        <h2 className="text-xl font-semibold text-gray-800">Client Overview</h2>
                    </div>
                    <div className="flex gap-2">
                        <Select
                            placeholder="Select Client"
                            options={constructOptions(
                                clientData?.filter(p => p?.status === 'active'),
                                "name",
                                "name",
                            )}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            isClearable
                            onChange={(e) => handleFilterClient(e)}
                            isLoading={clientListLoading}
                        />
                    </div>
                </div>

                <div className="overflow-x-auto">
                    <table className="min-w-full text-sm text-left border border-gray-200">
                        <thead className="bg-gray-100 text-gray-700 uppercase text-xs">
                            <tr>
                                <th className="px-4 py-3 border-b">Member</th>
                                <th className="px-4 py-3 border-b">Email</th>
                                <th className="px-4 py-3 border-b">Status</th>
                                <th className="px-4 py-3 border-b text-center">Total Billed</th>
                                <th className="px-4 py-3 border-b text-center">Total Paid</th>
                                <th className="px-4 py-3 border-b text-center">Outstanding</th>
                                <th className="px-4 py-3 border-b text-center">Analytics</th>
                            </tr>
                        </thead>
                        <tbody>
                            {showClientData && showClientData?.map((item, index) => (
                                <tr className="hover:bg-gray-50" key={index}>
                                    <td className="px-4 py-3">
                                        <div className="flex flex-col">
                                            <span className="font-medium text-gray-900">{item?.name}</span>
                                        </div>
                                    </td>
                                    <td className="px-4 py-3 text-start font-medium text-gray-800">{item?.email}</td>
                                    <td className="px-4 py-3">
                                        <span className={`${item?.status === "active" ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'} text-xs px-2 py-1 rounded`}>{item?.status}</span>
                                    </td>
                                    <td className="px-4 py-3 text-center font-medium text-gray-800">$ {item?.total_amount || "--"}</td>
                                    <td className="px-4 py-3 text-center font-medium text-gray-800">$ {item?.total_due || "--"}</td>
                                    <td className="px-4 py-3 text-center font-medium text-red-600">$ {item?.total_paid || "--"}</td>
                                    <td className="px-4 py-3 text-center">
                                        <button
                                            onClick={() => handleClientAnalytics(item)} // Your handler
                                            className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 font-medium text-sm px-3 py-1.5 rounded-full shadow-sm transition-all duration-200"
                                        >
                                            <FontAwesomeIcon icon={faChartBar} className="text-indigo-600 text-sm" />
                                            Analytics
                                        </button>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="add-provider-title"
                aria-describedby="add-provider-description"
            >
                <Box sx={style}>
                    <div className="flex justify-between">
                        <div className="flex w-100 gap-4">
                            <h3>{heading?.name}</h3>
                            <div className='date-picker-dash modalfilter'>
                                <DatePicker
                                    value={selectedRange}
                                    onChange={(e) => handleChangeChart(e)}
                                    range
                                    onlyMonthPicker
                                    inputClass="custom-input"
                                    format="MMMM YYYY"
                                    placeholder="Select month and year"
                                />
                            </div>
                        </div>
                        <button
                            onClick={handleClose} // define this function
                            className="bg-red-100 text-red-700 hover:bg-red-200 px-3 py-1 rounded-md text-sm font-medium transition-all shadow-sm"
                        >
                            Close
                        </button>
                    </div>
                    <div className="flex items-center justify-center">
                        <RevenueChart showChartData={clientGraphData} />
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

export default TableViewDashboard;
